module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.responses && _vm.categories) ? _c('section', {
    staticClass: "textSection"
  }, [_c('h1', [_vm._v("Formation Savoir Être Aidant")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getUser),
      expression: "getUser"
    }],
    staticClass: "category-container"
  }, [_c('p', [_vm._v("Commencez des à présent la formation Savoir Être Aidant.\n            Toutes les catégories sont présentes ici pour que vous testiez vos connaissances à l'aide des vidéos disponibles sur le site,\n            veuillez les regarder au préalable avant de vous évaluer sur le sujet.\n        ")]), _vm._v(" "), _c('nav', {
    staticClass: "fthematicMenuBar button-group thematics",
    attrs: {
      "id": "navbar"
    }
  }, _vm._l((_vm.categoriesWithQuestionnaire), function(category) {
    return _c('router-link', {
      key: category.id,
      class: _vm.validCategory(category.id),
      attrs: {
        "to": '/' + category.code
      },
      nativeOn: {
        "click": function($event) {
          return _vm.selectCategory()
        }
      }
    }, [_vm._v("\n                " + _vm._s(category.name) + "\n            ")])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "progress-container"
  }, [_c('p', {
    staticStyle: {
      "margin-top": "0"
    }
  }, [_vm._v("Vous pouvez tester vos connaissances directement en sélectionnant la catégorie que vous souhaitez, vous serez redirigé sur la catégorie\n            avec les vidéos correspondantes et le quiz.")]), _vm._v(" "), (!_vm.completed) ? _c('p', [_vm._v(" Une fois toute les catégories complétées, vous pourrez télécharger votre certification au MOOC Savoir être Aidant.")]) : _c('p', [_vm._v("Bravo ! Vous avez réussi à compléter toutes les catégories, vous pouvez télécharger votre certification\n                au MOOC Savoir être Aidant "), _c('strong', {
    staticClass: "downloadPDF",
    on: {
      "click": function($event) {
        return _vm.getNames()
      }
    }
  }, [_vm._v("ici")]), _vm._v(".")]), _vm._v(" "), _c('a'), _vm._v(" "), _c('div', [_c('p', [_vm._v("Vous avez réussi " + _vm._s(_vm.width) + "/" + _vm._s(_vm.categoriesWithQuestionnaire.length) + " catégories !")]), _vm._v(" "), _c('div', {
    staticClass: "bar"
  }, [_c('div', {
    staticClass: "percentage has-tip",
    style: ({
      'width': _vm.validCategories() + '%'
    })
  })])])]), _vm._v(" "), (_vm.edit) ? _c('div', [_c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container formation",
    attrs: {
      "id": "formation"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('h2', [_vm._v("Informations")]), _vm._v(" "), _c('div', {
    staticClass: "contact-form"
  }, [_c('form', {
    staticClass: "form-contact"
  }, [_c('label', [_vm._v("Nom *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nom),
      expression: "nom"
    }],
    attrs: {
      "type": "text",
      "required": "required",
      "placeholder": "Nom"
    },
    domProps: {
      "value": (_vm.nom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nom = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Prenom *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prenom),
      expression: "prenom"
    }],
    attrs: {
      "type": "text",
      "required": "required",
      "placeholder": "Prenom"
    },
    domProps: {
      "value": (_vm.prenom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.prenom = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "civilite"
    }
  }, [_vm._v("Civilité *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.civilite),
      expression: "civilite"
    }],
    attrs: {
      "id": "civilite",
      "required": "required"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.civilite = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "m"
    }
  }, [_vm._v("Homme")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "f"
    }
  }, [_vm._v("Femme")])]), _vm._v(" "), _c('div', {
    staticClass: "valider"
  }, [_c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.editNames()
      }
    }
  }, [_vm._v("Valider")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.edit = false
      }
    }
  }, [_vm._v("Annuler")])])])])])])])])])], 1) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85c2ceee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Formation.vue
// module id = 452
// module chunks = 1